import { cookieExists, SingleValueCookie } from 'saddlebag-cookie';

const PREFERENCES_COOKIE_NAME = 'preferences';

export const clearPreferencesCookie = () => {
  try {
    if (cookieExists(PREFERENCES_COOKIE_NAME)) {
      new SingleValueCookie(PREFERENCES_COOKIE_NAME).remove();
    }
  } catch (error) {
    // No action required. We don't want the error to bleed out, but this is temporary cleanup code that will be removed in ZIGGY-4663.
  }
};
